import React, { useEffect, useState } from "react";
import UploadFile from "../../../../components/upload/UploadFile";
import { StudentApi } from "../../../../api/student/student.api";
import { alertError, alertSuccess } from "../../../../components/alert/swal";
import { useTranslation } from "react-i18next";

const CertificateList = ({ student_id }: { student_id: number }) => {
  const { t } = useTranslation();
  const [data, setData] = useState<any>([]);

  const getCertificate = async (student_id: number) => {
    const res = await StudentApi.fetchGetCertificateDocument(student_id);
    const data = res.data;
    if (data.status < 300) {
      setData(data.data);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (student_id) {
      getCertificate(student_id);
    }
  }, [student_id]);

  const handleDownloadFile = async (id_student_certificate: number) => {
    await StudentApi.fetchGetCertificateDocumentDownload(id_student_certificate)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess(t("สำเร็จ"), t("ดาวน์โหลดไฟล์เรียบร้อย"), t("ตกลง"));
        }
      })
      .catch((error) => alertError(t("ดาวน์โหลด ไม่สำเร็จ")))
      .finally(() => {});
  };

  return (
    <section className="w-full my-2 gap-4">
      {data && data.length > 0
        ? data.map((item: any, index: number) => {
            return (
              <div
                key={index + 1}
                style={{
                  marginTop: 8,
                }}
              >
                <UploadFile
                  fileAttachmentId={item.id_student_certificate}
                  fileAttachmentName={item.certificate_name}
                  noClick={true}
                  onDeleteFile={() => {}}
                  onDrop={() => {}}
                  // file={item?.file_path}
                  formatText={t("FILE_UPLOAD.FILE_SIZE")}
                  disableDeleteFileId={true}
                  onDeleteFileId={() => {}}
                  hiddenDownloadFile={false}
                  onDownloadFile={() => {
                    handleDownloadFile(item.id_student_certificate);
                  }}
                />
              </div>
            );
          })
        : null}
    </section>
  );
};

export default CertificateList;
